import type { CacheConfig } from '@/types/shared/caching.types'

export const ORGANIZATION_CACHE_CONFIG: Record<string, CacheConfig> = {
  'org.profile': {
    autosave: true,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization', 'profile'],
  },
  'organization.branches': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization-branches'],
  },
  'organization.roles': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization-roles'],
  },
  'organization.groups': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization-groups'],
  },
  'organization.settings': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization-settings'],
  },
}
